import { xzztcUrl} from '@/config/net.config.js'
import request from '@/utils/request'
// import qs from 'qs'
//提交反馈
export function saveFeedback(data) {
  return request({
    url: xzztcUrl+'/api/xzztc/feedback/addFeedback',
    head: 'application/json;charset=UTF-8',
    token:sessionStorage.getItem("xzztcToken"),
    data,
    method: 'post',
  })
}
//获取反馈类型
export function queryFeedbackType(){
	return request({
		url:xzztcUrl+'/api/xzztc/feedback/queryFeedbackType',
        token:sessionStorage.getItem("xzztcToken"),
		method:'get'
	})
}